<template>
    <div>
        <table>
            <tr>
                <td>
                    <p-radio v-model="settings.mode" :name="'mode-'+settings.uid" value="solvent">Solvent</p-radio>
                </td>
                <td>
                    <treeselect :disabled="settings.mode !== 'solvent'" class="smalltreeselect" :disable-branch-nodes="true" placeholder="Select Solvent" :options="solvents" v-model="settings.tip_solv"/>
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>
                    <p-radio v-model="settings.mode" :name="'mode-'+settings.uid" value="needle">Needle</p-radio>
                </td>
                <td>
                    <select :disabled="settings.mode !== 'needle'" v-model="settings.needle_solv">
                        <option v-for="needle in needles" :value="needle">{{needle}}</option>
                    </select>
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>
                    Volume
                </td>
                <td>
                    <vue-numeric 
                        thousand-separator="'" 
                        :precision="2" 
                        :min="0" 
                        :max="135" 
                        currency="ml" 
                        currency-symbol-position="suffix" 
                        decimal-separator="." 
                        v-model="settings.volume_solv"
                    />
                </td>
                <td></td>
                <td></td>
            </tr>
        </table>
    </div>
</template>


<script>
import actionMixin from './action.mixin';

export default {
    mixins: [actionMixin],
    methods: {
    },
    props: [
        'lastsolvent'
    ],
    data: function(){return{
        needles: [
            'ND1',
            'ND2'
        ],
        solvents: this.$store.state.solvents.map(s=>({
            label: s.solventName,
            id: s.solventName
        })),
    }},
    beforeMount: function(){
        Vue.set(this.settings, 'inputTypes', ['ExSample','MiniSample','SnapvialSample']);
        //Vue.set(this.settings, 'outputType', 'SnapvialSample');

        this.setDefault('tip_solv', this.lastsolvent); 
        this.setDefault('needle_solv', 'ND2');
        this.setDefault('volume_solv', 0.1);
        this.setDefault('mode', 'solvent');
        
    }
}

</script>

<style>
    
</style>

<style lang="scss" src="./action.scss" scoped>